import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { PackagingApiAdapter } from '@modules/Packaging/materialAlmacen/adapters/PackagingApiAdapter';
import { OwnBoxPackaging } from '../models/rate.types';

export async function fetchAllActiveOwnBoxes(): Promise<OwnBoxPackaging[]> {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new PackagingApiAdapter(httpClient);

  const allItems: OwnBoxPackaging[] = [];
  let page = 1;
  let hasMore = true;

  while (hasMore) {
    const response = await adapter.getPackagingPaginated({
      categories: ['own_box'],
      active: true,
      page,
      limit: 100,
    });

    allItems.push(
      ...response.items.map((item) => ({
        id: item.id,
        name: item.name,
        code: item.code,
        pvp: item.pvp,
      })),
    );

    hasMore = response.hasMore;
    if (response.nextPage) {
      page = response.nextPage;
    } else {
      hasMore = false;
    }
  }

  return allItems;
}

export const useActiveOwnBoxes = (enabled = true) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['activeOwnBoxes'],
    queryFn: fetchAllActiveOwnBoxes,
    enabled,
    staleTime: 5 * 60 * 1000,
  });

  return {
    ownBoxes: data ?? [],
    isLoading,
    error,
    refetch,
  };
};
